// FUNCTIONS
export function loadScript(script_src, callback_function){
    const script = document.createElement("script");
    script.src = script_src;
    script.async = true;
    script.onload = callback_function;

    document.body.appendChild(script);

}